
import AppMobileFullScreenContainer from "@/components/common/MobileFullScreenContainer.vue";
import AppToolbar from "@/components/common/ToolbarBase.vue";
import Vue from "vue";
import { DefaultEditTab, getVisibleDefaultEditTabs } from "@/utils/tabs/default-edit-tabs";
import { Purchase } from "@/models/base";
import AppDefault from "./PurchaseInfoDefault.vue";
import AppInfoVat from "./PurchaseInfoVat.vue";
import AppPurchaseInfoContact from "./PurchaseInfoContact.vue";
import { AuthService, DossierConfigService } from "@/services";
import AppExtraFieldTab from "@/components/ExtraFieldTab.vue";
import { ExtraFieldTabConfig } from "@/models/dossier-configs/extra-field-tab-config";
import { ExtraFieldNamesConfig } from "@/models/dossier-configs/extra-field-names-config";
import { MODULE } from "@/config/modules";
import AppPurchaseInfoLedgersCard from "./PurchaseInfoLedgersCard.vue";
import AppPurchaseInfoExtraFields from "./PurchaseInfoExtraFields.vue";
import { ExactSyncService } from "@/services/exact-sync-service";
import { ClearfactsSyncService } from "@/services/clearfacts-sync-service";
import { tokenStore } from "@/utils/token-store";

export default Vue.extend({
	data() {
		return {
			toSetFile: null as File | null,
			removeFile: false,
			editLedgersOpen: false,
			isPushingToExact: false,
			isPushingToClearfacts: false,
			tab: 0
		};
	},
	props: {
		value: {
			type: Object as () => Purchase,
			required: true
		},
		canEdit: Boolean
	},
	computed: {
		hasLedgerModule():boolean {
			// Was vroeger enkel BTW-aangifte. Maar in de offline was het de module boekhoudlijsten. Daarom worden bijden aanvaard
			return AuthService.hasModule(MODULE.BTW_AANGIFTE_EN_LISTING) || AuthService.hasModule(MODULE.BOEKHOUDLIJSTEN);
		},
		defaultTabs(): DefaultEditTab[] {
			return getVisibleDefaultEditTabs(9, tab => tab.key != "purchase-validation");
		},
		currentTabKey(): string {
			return this.defaultTabs[this.tab]?.key || "";
		},
		tabs():string[]{
			return [...this.defaultTabs.map(t=>t.label()), ...this.extraFieldNamesConfig.getTabNames()];
		},
		extraFieldNamesConfig():ExtraFieldNamesConfig {
			return DossierConfigService.getExtraFieldNamesConfigs().PurchaseNames;
		},
		extraFieldTabs():ExtraFieldTabConfig[] {
			return this.extraFieldNamesConfig.getTabs();
		},

		isAccountant():boolean {
			return tokenStore.isAccountant;
		},
	},
	methods: {
		async edit() {
			this.$router.push(`/purchase/edit/${this.value.ID}`);
		},
		cancel() {
			this.$emit("cancel");
		},
		openLedgers(){
			this.editLedgersOpen = true;
		},
		async pushToClearfacts() {
			if (this.isPushingToClearfacts) return;
			this.isPushingToClearfacts = true;
			try {
				await ClearfactsSyncService.pushPurchase(this.value.ID, this.value.BookYear);
				this.$wf.notify(this.$ct("push-to-clearfacts-success").toString(), "success", 4000, "check");
			} catch (err) {
				let msg = (err as any)?.message || "";
				this.$wf.notify(this.$ct("push-to-clearfacts-failed", {error: msg}).toString(), "error", 6000, "exclamation-triangle");
			} finally {
				this.isPushingToClearfacts = false;
			}
		},
		async pushToExact() {
			if (this.isPushingToExact) return;
			this.isPushingToExact = true;
			try {
				let res = await ExactSyncService.pushPurchase(this.value.ID, this.value.BookYear);
				this.$wf.notify(this.$ct("push-to-exact-success", {id: res.EntryID}).toString(), "success", 4000, "check");
				if (res.AttachmentError) {
					this.$wf.notify(this.$ct("push-to-exact-attachment-failed", {error: res.AttachmentError}).toString(), "warning", 8000, "exclamation-triangle");
				}
			} catch (err) {
				let msg = (err as any)?.message || "";
				this.$wf.notify(this.$ct("push-to-exact-failed", {error: msg}).toString(), "error", 6000, "exclamation-triangle");
			} finally {
				this.isPushingToExact = false;
			}
		},
	},
	components: {
		AppDefault,
		AppInfoVat,
		AppToolbar,
		AppMobileFullScreenContainer,
		AppPurchaseInfoContact,
		AppPurchaseInfoLedgersCard,
		AppPurchaseInfoExtraFields,
		AppExtraFieldTab
	},
	i18nEx: {
		componentPrefix: "components.purchases"
	}
});
